import React from "react";
import { motion } from "framer-motion";
import { Typewriter } from "react-simple-typewriter";
import { FaDownload, FaLinkedin, FaGithub } from "react-icons/fa";
import profileImg from "../assets/Images/tefeena-john.png";
import "../assets/css/Hero.css";

const containerVariants = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.2,
    },
  },
};

const itemVariants = {
  hidden: { opacity: 0, y: 30 },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      ease: "easeOut",
      duration: 1,
    },
  },
};

const Hero = () => {
  return (
    <section id="hero" className="hero-section">
      {/* === TEXT SECTION === */}
      <motion.div
        variants={containerVariants}
        initial="hidden"
        animate="visible"
        className="text-container w-full max-w-xl space-y-6 z-10"
      >
        <motion.h1
          variants={itemVariants}
          className="text-3xl sm:text-4xl md:text-5xl font-bold leading-tight"
        >
          Hi, I'm <span className="text-[#D20062]">Tefeena</span>
          <br />
          <span className="text-[#D20062] font-bold glow-type">
            <Typewriter
              words={[
                "Full Stack Developer",
                "Frontend Developer",
                "Web Developer",
                "Angular Developer",
                "React Developer",
              ]}
              loop={0}
              cursor
              cursorStyle="|"
              typeSpeed={70}
              deleteSpeed={50}
              delaySpeed={1500}
            />
          </span>
        </motion.h1>

        <motion.p
          variants={itemVariants}
          className="text-gray-300 text-sm sm:text-base"
        >
          I'm a creative and detail-driven Full Stack Developer with over 6 years
          of experience crafting elegant, high-performance web interfaces. I
          thrive on turning complex concepts into seamless, user-centered
          digital experiences that not only look great but feel intuitive.
        </motion.p>

        <motion.div
  variants={itemVariants}
  className="download-wrapper flex flex-wrap  gap-4 mt-4 sm:mt-6 "
>
  <motion.a
    href="/Tefeena_resume.pdf"
    download
    whileHover={{ scale: 1.1, rotate: 2 }}
    whileTap={{ scale: 0.95 }}
    className="hero-button bg-gradient-to-r from-[#55e6a5] to-[#FFC300] text-black px-6 py-3 rounded-md font-semibold flex items-center gap-2 shadow-xl hover:shadow-yellow-400/40 transition-transform duration-300 animate-bounce-slow"
  >
    <FaDownload className="animate-pulse" /> Download CV
  </motion.a>

  <div className="social-icons-wrapper flex justify-center gap-4">
    <motion.a
      href="https://www.linkedin.com/in/tefeena/"
      target="_blank"
      rel="noopener noreferrer"
      whileHover={{ scale: 1.3, rotate: 15 }}
      whileTap={{ scale: 0.95 }}
      className="text-[#55e6a5] bg-[#ffffff12] p-3 rounded-full hover:bg-[#ffffff20] transition duration-300 shadow-md hover:shadow-[#55e6a566] animate-float"
    >
      <FaLinkedin className="text-2xl" />
    </motion.a>

    <motion.a
      href="https://github.com/tefeena"
      target="_blank"
      rel="noopener noreferrer"
      whileHover={{ scale: 1.3, rotate: -15 }}
      whileTap={{ scale: 0.95 }}
      className="text-[#55e6a5] bg-[#ffffff12] p-3 rounded-full hover:bg-[#ffffff20] transition duration-300 shadow-md hover:shadow-[#55e6a566] animate-float"
    >
      <FaGithub className="text-2xl" />
    </motion.a>
  </div>
</motion.div>

      </motion.div>

      {/* === IMAGE SECTION === */}
      <motion.div
        className="hero-img-wrapper z-10 mx-auto group"
        initial={{ opacity: 0, scale: 0.8 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 1.3, ease: "easeOut" }}
        whileHover={{ scale: 1.03 }}
      >
        <div className="glow-border"></div>
        <img
          src={profileImg}
          alt="Tefeena"
          className="profile-img"
        />
      </motion.div>
    </section>
  );
};

export default Hero;
